import { useCallback } from 'react';

import ChevronLeftRoundedIcon from '@mui/icons-material/ChevronLeftRounded';
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';
import { useParams, useNavigate } from 'react-router-dom';

import { useIntl } from '@zenbusiness/application-commons-intl';
import Box from '@zenbusiness/zui/Box';
import Button from '@zenbusiness/zui/Button';
import Text from '@zenbusiness/zui/Text';

import { StyledFocusHeader } from '../SubscriptionCancelPage.styles';

const SUBSCRIPTIONS_PATH = (businessEntityUuid) => `/dashboard/${businessEntityUuid}/subscription-hub/billing/subscriptions`;

export function SubscriptionCancelHeader({ onBack, onClose }) {
  const { businessEntityUuid } = useParams();
  const navigate = useNavigate();
  const { formatMessage } = useIntl();

  const handleClose = useCallback(
    () => (onClose ? onClose() : navigate(SUBSCRIPTIONS_PATH(businessEntityUuid))),
    [onClose, navigate, businessEntityUuid]
  );

  return (
    <StyledFocusHeader>
      {onBack ? (
        <Button variant="text" onClick={onBack} startIcon={<ChevronLeftRoundedIcon />}>
          {formatMessage({ id: 'dashboard.subscriptionCancel.header.back' })}
        </Button>
      ) : (
        <Box visibility="hidden" aria-hidden>
          <Button variant="text" startIcon={<ChevronLeftRoundedIcon />} tabIndex={-1}>
            {formatMessage({ id: 'dashboard.subscriptionCancel.header.back' })}
          </Button>
        </Box>
      )}
      <Text size="xl" weight="bold">
        {formatMessage({ id: 'dashboard.subscriptionCancel.header.title' })}
      </Text>
      <Button variant="text" onClick={handleClose} endIcon={<CloseIcon fontSize="small" />}>
        {formatMessage({ id: 'dashboard.subscriptionCancel.header.close' })}
      </Button>
    </StyledFocusHeader>
  );
}

SubscriptionCancelHeader.propTypes = {
  onBack: PropTypes.func,
  onClose: PropTypes.func
};
